import {
  AppBar,
  Avatar,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from "@mui/material";
import { colorVariables, customValue } from "../../utils/colorVariable";
import { useLocation, useNavigate } from "react-router-dom";
import { EROUTER } from "../../utils/enumVariable";
import { SettingIcon } from "../assets/Icons/SettingIcon";
import { GlobalMenu } from "../globalMenu/GlobalMenu";
import { Logout, AccountCircle, Replay } from "@mui/icons-material";
import {  Suspense, useCallback, useEffect, useState } from "react";
import { LINKS, SUB_MENU } from "../../constants/menu";
import { checkTokenValidity, useAuth } from "../../modules/user/services/AuthProvider";
import { IUser } from "../../modules/user/model/user";
import { CanAccessFunctionality } from "../common/Privilege/FunctionPrivilegeCheck";
import { socket_client } from "../../socket";
import { IPoNotification } from "../../modules/orders/models/notification";
import dayjs from "dayjs";
import { getCurrentUser } from "../../utils/user";
import { initiateTabUrl, initiateWarehouseUrl } from "../../utils/urlStorage";
import { E_FUNCTIONALITY } from "../../utils/functionalityVariable";
import { IYarnOrder } from "../../modules/raw-material/models/yarn";
import { useGetUserById } from "../../modules/user/hooks/useUsers";

export const Header = () => {
  const location = useLocation();
  const isPublicAuthRoute =
    location.pathname.toString().includes(EROUTER.SIGNIN) ||
    location.pathname.toString().includes(EROUTER.SIGNUP) ||
    location.pathname.toString().includes(EROUTER.ACTIVATE_ACCOUNT);

  if (isPublicAuthRoute) {
    return null;
  }

  return <HeaderContent />;
};

const HeaderContent = () => {

  const location = useLocation();
  const { isAuthenticated, logout } = useAuth();

 // const [total, setTotal] = useState<number>(0);


  //const [orderNotifications, setOrderNotifications] = useState<
  //  Array<IPoNotification>
  //>([]);



  const [currentUser, setCurrentUser] = useState<Partial<IUser>>(() =>
    getCurrentUser()
  );
  const { id_user, firstName, lastName, email, matricule, avatar } =
    currentUser;
  const [currentAvatar, setCurrentAvatar] = useState<string>("");
  const [isAvatarLoaded, setIsAvatarLoaded] = useState(false);
  const { data: userData, refetch: refetchUser } = useGetUserById({
    id_user: id_user || 0,
    queryOptions: { 
      enabled: isAuthenticated && !!id_user && checkTokenValidity(),
      retry: false,
    },
  });

  useEffect(() => {
    setCurrentUser(getCurrentUser());
  }, [isAuthenticated, location.pathname]);

  useEffect(() => {
    if (id_user) {
      setIsAvatarLoaded(false);
      setCurrentAvatar("");
    }
  }, [id_user]);

  useEffect(() => {
    if (userData?.data) {
      setCurrentUser((prev) => ({ ...prev, ...userData.data }));
      setCurrentAvatar(userData.data.avatar || "");
    }
    setIsAvatarLoaded(true);
  }, [userData?.data, userData?.data?.avatar]);

  useEffect(() => {
    const handleAvatarUpdate = (event: CustomEvent) => {
      const newAvatar = event.detail?.avatar;
      if (newAvatar) {
        setCurrentUser((prev) => ({ ...prev, avatar: newAvatar }));
        setCurrentAvatar(newAvatar);
        setIsAvatarLoaded(true);
        refetchUser();
      }
    };

    window.addEventListener('avatarUpdated', handleAvatarUpdate as EventListener);
    
    return () => {
      window.removeEventListener('avatarUpdated', handleAvatarUpdate as EventListener);
    };
  }, [refetchUser]);



  useEffect(() => {
    const handleNewOrder = ({
      audit_logs,
      order,
      user,
    }: {
      order: IYarnOrder;
      audit_logs: IPoNotification;
      user: IUser;
    }) => {
      //setTotal((prev) => prev + 1);

     /* setOrderNotifications((prev) => {
        return [
          {
            ...audit_logs,
            order_details: order,
            user_details: user,
            timestamp: dayjs(new Date()),
          },
          ...(prev ? prev.slice(0, -1) : []),
        ];
      });*/
    };

    socket_client.on("newOrder", handleNewOrder);

    return () => {
      socket_client.off("newOrder", handleNewOrder);
    };
  }, []);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [settingAnchorEl, setSettingAnchorEl] = useState<null | HTMLElement>(
    null
  );
  const open = Boolean(anchorEl);

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuSetting = (event: React.MouseEvent<HTMLElement>) => {
    setSettingAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuCloseSetting = () => {
    setSettingAnchorEl(null);
  };

  const handleLogout = useCallback(() => {
    setAnchorEl(null);
    //setTotal(0);
    setCurrentUser({});
    setCurrentAvatar("");
    setIsAvatarLoaded(false);
    initiateTabUrl();
    initiateWarehouseUrl();
    logout("");
  }, [logout]);

  const navigate = useNavigate();

  const onNavigate = useCallback(
    (link: string) => () => {
      navigate(link);
    },
    [navigate]
  );



  const onNavigateLink = useCallback(
    (link: string) => () => {
      navigate(link);
      handleMenuCloseSetting();
      handleMenuClose();
    },
    [navigate]
  );

  const onRefetch = useCallback(() => {
    navigate(0);
  }, [navigate]);

  return (
    <AppBar
      component="nav"
      elevation={0}
      position="fixed"
      sx={{
        bgcolor: colorVariables.white,
        borderColor: colorVariables.gray,
        color: "#000",
      }}
    >
      <Toolbar
        sx={{
          display: { xs: "flex" },
          justifyContent: { xs: "space-between" },
        }}
      >
        <Box
          display={"flex"}
          flexDirection={"row"}
          alignItems={"center"}
          justifyContent={"center"}
          sx={{ cursor: "pointer" }}
          onClick={onNavigate(LINKS.HOME)}
        >
          <img
            src={`${process.env.PUBLIC_URL}/accord_knits.png`}
            alt="Logo"
            style={{
              height: 60,
              width: "auto",
              padding: 4,
              borderRadius: customValue.borderRadius,
              backgroundColor: "white",
              mixBlendMode: "multiply",
            }}
          />
          <Typography variant="h6" sx={{ color: "#5E686D" }} fontWeight={300}>
            Accord Knits
          </Typography>
        </Box>
        <Box display={"flex"} alignItems={"center"}>





          <GlobalMenu />
          <IconButton onClick={onRefetch}>
            <Replay />
          </IconButton>
       
          <IconButton
            onClick={handleMenuSetting}
            sx={{
              display: !CanAccessFunctionality({
                user_functionalities: [E_FUNCTIONALITY.menu_setting],
              })
                ? "none"
                : "",
            }}
          >
            <SettingIcon />
          </IconButton>
          <Menu
            anchorEl={settingAnchorEl}
            open={Boolean(settingAnchorEl)}
            onClose={handleMenuCloseSetting}
            sx={{ mt: 1 }}
          >
            {/* ── USERS ─────────────────────────────────────────── */}
            {SUB_MENU.users.some(item => CanAccessFunctionality({ user_functionalities: item.user_functionalities })) && (
              <>
                <Typography sx={{ px: 1, color: colorVariables.black, fontSize: ".9em" }}>
                  {"USERS"}
                </Typography>
                <Box width={"100%"} sx={{ bgcolor: "#eee", height: 1.2, my: 0.6 }} />
                {SUB_MENU.users
                  .filter(item => CanAccessFunctionality({ user_functionalities: item.user_functionalities }))
                  .map((item, index) => (
                    <MenuItem
                      sx={{ borderBottom: "1px solid " + colorVariables.gray, fontSize: 13 }}
                      onClick={onNavigateLink(item.link)}
                      key={index}
                    >
                      {item.label}
                    </MenuItem>
                  ))
                }
              </>
            )}

            {/* ── MANAGEMENTS ───────────────────────────────────── */}
            {SUB_MENU.managements.some(item => CanAccessFunctionality({ user_functionalities: item.user_functionalities })) && (
              <>
                <Typography sx={{ px: 1, color: colorVariables.black, fontSize: ".9em" }}>
                  {"MANAGEMENTS"}
                </Typography>
                <Box width={"100%"} sx={{ bgcolor: "#eee", height: 1.2, my: 0.6 }} />
                {SUB_MENU.managements
                  .filter(item => CanAccessFunctionality({ user_functionalities: item.user_functionalities }))
                  .map((item, index) => (
                    <MenuItem
                      sx={{ borderBottom: "1px solid " + colorVariables.gray, fontSize: 13 }}
                      onClick={onNavigateLink(item.link)}
                      key={index}
                    >
                      {item.label}
                    </MenuItem>
                  ))
                }
              </>
            )}
          </Menu>
          <Typography
            sx={{ 
              mr: 1, 
              color: colorVariables.grayText, 
              fontSize: ".9em",
              fontWeight: 500
            }}
          >
            {matricule || ""}
          </Typography>
          <IconButton onClick={handleMenuClick}>
            {isAuthenticated && (() => {
              let avatarSrc: string | undefined;
              if (!isAvatarLoaded) {
                avatarSrc = undefined;
              } else if (currentAvatar) {
                avatarSrc = currentAvatar;
              } else if (!avatar) {
                avatarSrc = `${process.env.PUBLIC_URL}/image/user.png`;
              }
              return (
                <Avatar
                  src={avatarSrc}
                  alt="user"
                  key={currentAvatar}
                  sx={{
                    opacity: isAvatarLoaded ? 1 : 0.5,
                    transition: 'opacity 0.3s ease-in-out'
                  }}
                />
              );
            })()}
          </IconButton>
          {/* Dropdown Menu */}
          <Menu anchorEl={anchorEl} open={open} onClose={handleMenuClose}>
            <Typography
              sx={{ px: 1, color: colorVariables.black, fontSize: ".9em" }}
            >
              {`${firstName || ""} ${lastName || ""}`}
            </Typography>
            <Typography
              sx={{ px: 1, color: colorVariables.grayText, fontSize: ".8em" }}
            >
              {email || ""}
            </Typography>
            <Box
              width={"100%"}
              sx={{ bgcolor: "#eee", height: 1.2, my: 0.6 }}
            ></Box>
            <MenuItem
              onClick={onNavigateLink(LINKS.PROFILE)}
              sx={{ fontSize: ".9em" }}
            >
              <AccountCircle sx={{ mr: 1, color: colorVariables.grayText }} />
              Profile
            </MenuItem>
            <MenuItem onClick={handleLogout} sx={{ fontSize: ".9em" }}>
              <Logout sx={{ mr: 1, color: colorVariables.grayText }} />
              Logout
            </MenuItem>
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
};
